export default __webpack_public_path__ + "76e406b25eb912290a83766ba0f6da04.jpg";